const data = [
  {
    nickname: "Marek",
    picture:
      "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
  },
  {
    nickname: "Moniak23",
    picture:
      "https://s.gravatar.com/avatar/e32bd13e2add097461cb96824b7a829c?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fte.png",
  },
];

export default data;
